export const isNullOrWhiteSpace = (str?: string) =>
  str == null || str.trim() === '';
